import React, { useState, useEffect } from 'react';
import { Form, Field } from 'react-final-form';
import axios from 'axios';

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

const WebformApp = () => {

    const [token, setToken] = useState(null);
    const [bauerCookie, setBauerCookie] = useState(null);

    if (document.querySelector(".gated-webform-close") !== null) {
        var gatedclosebutton = document.querySelector(".gated-webform-close");
        gatedclosebutton.addEventListener("click", gatedClose);
        function gatedClose() {
            const closeGatedWebformByX = document.getElementById("gated-webform");
            closeGatedWebformByX.style.display = "none";

            const gatedButtons = document.querySelectorAll('.gated-button');
            gatedButtons.forEach((element) => {

                //console.log(element);
                if (element.classList.contains('pressed-gate')) {
                    element.classList.remove('pressed-gate');
                } else {
                    return false
                }
            });
        }
    }

    useEffect(() => {

        var x = getCookie('bauercookie');

        if (x !== "gated") {
            const buttons = document.querySelectorAll('.gated-button');
            for (let i = 0; i < buttons.length; i++) {
                buttons[i].addEventListener('click', e => e.preventDefault());
                buttons[i].addEventListener('click', (b) => {
                    const webformShow = document.getElementById("gated-webform");
                    webformShow.style.display = "block";

                    buttons[i].classList.add('pressed-gate');
                });
            }

        } else {
            //console.log("Cookie already set")
        }

        //console.log(bauerCookie)

    }, [bauerCookie]);

    useEffect(() => {

        fetch('/session/token')
            .then(function (response) {
                switch (response.status) {
                    // status "OK"
                    case 200:
                        return response.text();
                    // status "Not Found"
                    case 404:
                        throw response;
                }
            })
            .then(function (template) {
                setToken(template)
            })
            .catch(function (response) {
                // "Not Found"
                //console.log(response.statusText);
            });

    }, []);

    return (
        <>
            <div className="gated-webform-container">
                <div className="gated-webform-close">X</div>
                <div className="file-download-form-title">{Drupal.t('File Download Form')}</div>
                <div className="file-download-form-desc">{Drupal.t('Please submit this form before downloading the contents')}</div>
                <Form
                    validate={values => {
                        const errors = {}
                        if (!values.first_name) {
                            errors.first_name = 'Required *'
                        }
                        if (!values.last_name) {
                            errors.last_name = 'Required *'
                        }
                        if (!values.e_mail_address) {
                            errors.e_mail_address = 'Required *'
                        }
                        if (!values.company) {
                            errors.company = 'Required *'
                        }
                        if (!values.job_title) {
                            errors.job_title = 'Required *'
                        }
                        return errors
                    }}
                    onSubmit={(val) => handleSubmit(val, token, setBauerCookie)}
                    render={({ handleSubmit, form, submitting, pristine }) => (
                        <form onSubmit={handleSubmit} noValidate>
                            <div className="contact-form__container" id="contact-form__container">
                                <div className="contact-form__container--box" id="contact-form">
                                    <div className='form-group form-group-first-name'>
                                        <Field name='first_name'>
                                            {({ input, meta }) => (
                                                <>
                                                    <label htmlFor='first_name'>{Drupal.t("First Name *")}</label>
                                                    <input {...input} type='text' />
                                                    {meta.error && meta.touched && (
                                                        <span className='form-error-message'>{meta.error}</span>
                                                    )}
                                                </>
                                            )}
                                        </Field>
                                    </div>
                                    <div className='form-group form-group-last-name'>
                                        <Field name='last_name'>
                                            {({ input, meta }) => (
                                                <>
                                                    <label htmlFor='last_name'>{Drupal.t("Last Name *")}</label>
                                                    <input {...input} type='text' />
                                                    {meta.error && meta.touched && (
                                                        <span className='form-error-message'>{meta.error}</span>
                                                    )}
                                                </>
                                            )}
                                        </Field>
                                    </div>
                                    <div className='form-group form-group-email'>
                                        <Field name='e_mail_address'>
                                            {({ input, meta }) => (
                                                <>
                                                    <label htmlFor='e_mail_address'>{Drupal.t("E-mail Address *")}</label>
                                                    <input {...input} type='email' />
                                                    {meta.error && meta.touched && (
                                                        <span className='form-error-message'>{meta.error}</span>
                                                    )}
                                                </>
                                            )}
                                        </Field>
                                    </div>
                                    <div className='form-group form-group-company'>
                                        <Field name='company'>
                                            {({ input, meta }) => (
                                                <>
                                                    <label htmlFor='company'>{Drupal.t("Company *")}</label>
                                                    <input {...input} type='text' />
                                                    {meta.error && meta.touched && (
                                                        <span className='form-error-message'>{meta.error}</span>
                                                    )}
                                                </>
                                            )}
                                        </Field>
                                    </div>
                                    <div className='form-group form-group-job-title'>
                                        <Field name='job_title'>
                                            {({ input, meta }) => (
                                                <>
                                                    <label htmlFor='job_title'>{Drupal.t("Job Title *")}</label>
                                                    <input {...input} type='text' />
                                                    {meta.error && meta.touched && (
                                                        <span className='form-error-message'>{meta.error}</span>
                                                    )}
                                                </>
                                            )}
                                        </Field>
                                    </div>
                                    <div className="form-group form-group-industries">
                                        <label htmlFor="industries">{Drupal.t("Industries *")}</label>
                                        <Field name="industries" component="select">
                                            <option>{Drupal.t("- None -")}</option>
                                            <option value="1">{Drupal.t("Industrial Air")}</option>
                                            <option value="2">{Drupal.t("Breathing Air")}</option>
                                            <option value="3">{Drupal.t("Oil and Gas")}</option>
                                            <option value="4">{Drupal.t("CNG")}</option>
                                            <option value="5">{Drupal.t("Nitrogen")}</option>
                                            <option value="6">{Drupal.t("Plastics Technology")}</option>
                                            <option value="7">{Drupal.t("GSA/Military")}</option>
                                            <option value="8">{Drupal.t("Public Safety")}</option>
                                            <option value="9">{Drupal.t("MSA")}</option>
                                            <option value="10">{Drupal.t("Other")}</option>
                                        </Field>
                                    </div>
                                    <div className='form-group form-group-how-did'>
                                        <Field name='how_did_you_hear_about_us_'>
                                            {({ input, meta }) => (
                                                <>
                                                    <label htmlFor='how_did_you_hear_about_us_'>{Drupal.t("How did you hear about us?")}</label>
                                                    <input {...input} type='text' />
                                                    {meta.error && meta.touched && (
                                                        <span className='form-error-message'>{meta.error}</span>
                                                    )}
                                                </>
                                            )}
                                        </Field>
                                    </div>
                                    <div className="form-group form-group-simple-text">
                                        <div className="form-simple-text">{Drupal.t('We are committed to keeping your e-mail address confidential. BAUER COMPRESSORS may contact you. However, we do not sell, rent, or lease our contact data or lists to third parties, and we will not provide your personal information to any third party individual, government agency, or company.')}</div>
                                    </div>
                                </div>
                                <div className="submit-button__container">
                                    <button
                                        disabled={submitting}
                                        className='btn submit'
                                        data-text='submit'
                                        type='submit'>
                                        {Drupal.t("Send")}
                                    </button>
                                </div>
                            </div>
                        </form>
                    )}
                />
            </div>
        </>
    );
}

async function handleSubmit(values, token, setBauerCookie) {

    //console.log(token)

    var x = getCookie('bauercookie');
    //console.log(x)

    let base_data = {
        webform_id: 'file_download_form',
        in_draft: false
    };
    const data = {
        ...base_data,
        ...values
    };
    //console.log(data);

    const response = await axios.post(
        'https://www.bauercomp.com/react_webform_backend/submit',
        {
            ...data
        },
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': token
            }
        }
    );
    if (response.data.error) {
        //console.log("Error");
        //throw new WebformError(response);
    } else {
        setCookie('bauercookie', 'gated', 1);
        var bCookie = getCookie('bauercookie');
        setBauerCookie(bCookie)
        //console.log("Form submitted!");

        document.querySelector('.pressed-gate a').dispatchEvent(new MouseEvent("click", { bubbles: true, cancellable: true, view: window }));
        //document.querySelector('.pressed-gate a').click();

        const gatedButtons = document.querySelectorAll('.gated-button');
        gatedButtons.forEach((element) => {

            //console.log(element);
            if (element.classList.contains('pressed-gate')) {
                element.classList.remove('pressed-gate');
            } else {
                return false
            }
        });

        const webformHide = document.getElementById("gated-webform");
        webformHide.style.display = "none";
        location.reload();
    }
    //console.log(response);
    //console.log('Submitted');
}

export default WebformApp;